export default "__VITE_PUBLIC_ASSET__65473acc__"